class AuthService {
    login(identifier: Record<string, unknown>) {
        return fetch(
            process.env.REACT_APP_BASE_URL + '/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(identifier)
            }
        )
    }

    logout() {
        localStorage.removeItem('REACT_TOKEN_AUTH')
        localStorage.removeItem('LAST_URL')
        localStorage.removeItem('REACT_ROLE')
        localStorage.removeItem('REACT_ROLE_ORIGIN')
        localStorage.removeItem('REACT_TOKEN_AUTH_ORIGIN')
    }
}

const authServiceInstance = new AuthService();
export default authServiceInstance;